export default __webpack_public_path__ + "images/4c94800323ccde75b56ec2c8a88ac352-yoga.webp";